const ACCOUNT_CONTROLLER = 'api/isa/isagenixaccount';
const ACCOUNT_SESSION_API = '/sitecore/api/ssc/rw/isagenix/accountapi';
const CABO_API = '/api/isa/cabo';

export async function getMemberProfile(request) {
    let token = $('input[name="__RequestVerificationToken"]').val();
    return $.ajax({
        headers: {
            __RequestVerificationToken: token
        },
        type: 'POST',
        url: `${ACCOUNT_CONTROLLER}/CheckAndCreateMember`,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(request)
    });
}

export async function signOutMember(completeCallback) {
    let token = $('input[name="__RequestVerificationToken"]').val();
    return $.ajax({
        headers: {
            __RequestVerificationToken: token
        },
        type: 'POST',
        url: `${ACCOUNT_SESSION_API}/SignOutMember`,
        contentType: 'application/json',
        dataType: 'json',
        complete: completeCallback
    });
}

export async function changeCatalog(request) {
    let token = $('input[name="__RequestVerificationToken"]').val();
    let url = `${ACCOUNT_SESSION_API}/ChangeCatalog`;
    return $.ajax({
        headers: {
            __RequestVerificationToken: token
        },
        type: 'POST',
        url: url,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(request)
    });
}

export async function closeCABOSession() {
    let token = $('input[name="__RequestVerificationToken"]').val();
    return $.ajax({
        headers: {
            __RequestVerificationToken: token
        },
        type: 'POST',
        url: `${CABO_API}/CloseCABOSession`,
        contentType: 'application/json',
        dataType: 'json'
    });
}

export function isAuthenticatedUser() {
    return window.isUserAuthenticated;
}

export async function SetUpContext() {
    let token = $('input[name="__RequestVerificationToken"]').val();
    return $.ajax({
        headers: {
            __RequestVerificationToken: token
        },
        type: 'POST',
        url: `${ACCOUNT_SESSION_API}/SetUpContext`,
        contentType: 'application/json',
        dataType: 'json'
    });
}
